
import { faEnvelope, faLock } from '@fortawesome/pro-solid-svg-icons'

import AuthEntity from '@/lib/entities/auth'

export default {
  name: 'FormLogin',

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      faLock,
      faEnvelope
    }
  },

  computed: {
    compModel: {
      // Don't use v-model with a vuex store
      set(newValue) {
        this.$emit('input', newValue)
      },

      get() {
        return this.value
      }
    },

    compValidations() {
      return new AuthEntity().validation
    }
  },

  created() {
    this.compModel = { ...new AuthEntity().model, ...this.value }
  }
}
